"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("@mui/material"),e=require("@mui/material/styles"),s=require("./assets/icons/Arrow.js"),a=require("./assets/icons/Employees.js");require("react/jsx-runtime");const i=e.styled(t.Accordion)`
  max-height: auto;

  &.${t.accordionClasses.expanded} {
    margin-top: 0;
  }
`,c=e.styled(t.AccordionDetails)`
  padding: 0;
`,l=e.styled(t.AccordionSummary)(({theme:o})=>({backgroundColor:o.palette.grey[100],height:"48px",[`& .${t.accordionSummaryClasses.content}`]:{alignItems:"center"},[`&.${t.accordionSummaryClasses.expanded}`]:{minHeight:"auto"}})),d=e.styled(t.Button,{shouldForwardProp:o=>o!=="isOpen"})(({theme:o,isOpen:r,fullWidth:n})=>`
    flex-shrink: 0;
    width: auto;
 
    @media print {
      display: none;
    }
 
    background-color: ${r?o.palette.primary[50]:"#ffffff"};
    width: ${n?"100%":"initial"};
  `),p=e.styled(t.Button)(({theme:o})=>`
    && {
      color: ${o.palette.common.black};
    }
  `),u=e.styled(a)(()=>""),y=e.styled(s,{shouldForwardProp:o=>o!=="isOpen"})(({isOpen:o})=>`
    transform: ${o?"rotate(180deg)":"none"};
  `),m=e.styled(t.Menu,{shouldForwardProp:o=>o!=="width"&&o!=="maxHeight"})(({width:o,maxHeight:r})=>`
    & > .${t.paperClasses.root} {
      ${r?`max-height: ${r}px;`:""}
      width: ${o}px;
      overflow: scroll;
    }

    & .${t.paperClasses.root} {
      margin: 0;
    }

    & .${t.paperClasses.root}:before {
      display: none;
    }

    & .${t.paperClasses.root}:nth-child(2) {
      box-shadow: none;
      border-top: 1px solid #E0E0E0;
    }

    & .${t.paperClasses.root}:nth-child(1) {
      box-shadow: none;
    }

    & .${t.menuItemClasses.root} {
      & .${t.avatarClasses.root} + span {
        max-width: 102px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  `),h=e.styled(t.Divider)(({theme:o})=>({margin:0,backgroundColor:o.palette.grey[300]})),g=e.styled(t.Typography)({marginLeft:"8px",display:"inline"}),w=e.styled(t.Typography)(({theme:o})=>({color:o.palette.grey[800],marginRight:"8px"})),x=e.styled(t.Typography)(({theme:o})=>({color:o.palette.primary[900],backgroundColor:o.palette.primary[75],borderRadius:"50%",width:"18px",height:"18px",display:"flex",justifyContent:"center",alignItems:"center"}));exports.Accordion=i;exports.AccordionDetails=c;exports.AccordionSummary=l;exports.ArrowIcon=y;exports.DropdownButton=d;exports.DropdownText=p;exports.RoleCount=g;exports.SearchDivider=h;exports.SearchMenu=m;exports.StatusCount=x;exports.StatusTitle=w;exports.practitionersIcon=u;
